import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { Utils } from '@app/_helpers';
import { CURRENCY_LABEL, DEFAULT_PRECISION } from '@app/_helpers/constants';
import { FundsService } from '@app/_shared/providers/funds/funds.service';
import { PostSILoginRedirect } from '@app/app.structs';
import { PRODUCT_ID } from '@app/modules/trading/modules/profile/components/funds/funds.enums';
import { BrokerPlanDetails } from '@app/modules/trading/modules/profile/components/plans/plans.interface';
import { NotificationsService } from '@app/modules/trading/modules/profile/providers/notifications/notifications.service';
import { BrokerPlanConnectBrokerComponent } from '../broker-plan-connect-broker/broker-plan-connect-broker.component';

@Component({
  selector: 'app-broker-plan-payment-failed',
  templateUrl: './broker-plan-payment-failed.component.html',
  styleUrls: ['./broker-plan-payment-failed.component.scss']
})




export class BrokerPlanPaymentFailedComponent implements OnInit {

  requiredFunds: number;
  currentPlan: string;
  availableFunds: number = 0;
  CURRENCY_LABEL = CURRENCY_LABEL;
  DEFAULT_PRECISION = DEFAULT_PRECISION

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<BrokerPlanPaymentFailedComponent>,
    private router: Router,
    private dialog: MatDialog,
    private fundsService: FundsService,
    private notificationService: NotificationsService
  ) { }

  ngOnInit(): void {
    this.requiredFunds = this.data.transaction?.estimates?.amountdue;
    this.currentPlan = this.data.transaction?.planname;
  }


  redirectToPlans() {
      this.router.navigateByUrl('/trading/profile/user/plans');
      this.closeDialog();
  }

  openConnectToBroker() {

    const data: BrokerPlanDetails = {
      isCancelSubscription: true,
      redirectUrl: PostSILoginRedirect.funds
    }

    this.dialog.open(BrokerPlanConnectBrokerComponent, {
      width: '400px',
      panelClass: ['dialog-no-padding','border-radius-panel'],
      data
    })

    this.closeDialog();
  }

  closeDialog() {
    this.notificationService.markPersistantNotificationsAsRead(this.data.notificationId).subscribe(() => {
      this.dialogRef.close();
    });
  }

  getMargin() {
    this.fundsService.fetchMargin().subscribe(res => {
      const response = res.response;
      if (response.length) {
        response.forEach((data) => {
          if (data.product_id === PRODUCT_ID.ALL) {
            this.availableFunds = (data.withdrawable_margin && data.withdrawable_margin > 0) ? data.withdrawable_margin : Utils.withdrawMarginLimit(data);
          }
        })
      }

    }, _ => {
      console.log('failed to fetch margin')
    })
  }

}
